module.exports = __webpack_public_path__ + "static/media/back-white.a06bc3db.png";